import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import type { GlobalFilter } from '@hotjar/global-filters';
import type { PlanComparisonReferrer } from '@hotjar/webapp/features/Billing/PlanComparisonModal/types';
import { HeatmapFilterChain } from './HeatmapFilterChain';

const Container = styled.div`
  min-height: ${tokens.spacer.x5};
  display: flex;
  align-items: center;
  margin-bottom: ${tokens.spacer.x3};
`;

interface OptionsBarProps {
  selectedFiltersInUiFormat: GlobalFilter;
  onFiltersChange: (filtersInUiFormat: GlobalFilter, segmentId?: number) => void;
  onUpsellRequest: (featureName: PlanComparisonReferrer) => void;
}

export const OptionsBar = ({
  selectedFiltersInUiFormat,
  onFiltersChange,
  onUpsellRequest,
}: OptionsBarProps): JSX.Element => {
  return (
    <Container>
      <HeatmapFilterChain
        selectedFiltersInUiFormat={selectedFiltersInUiFormat}
        onFiltersChange={onFiltersChange}
        onUpsellRequest={onUpsellRequest}
      />
    </Container>
  );
};
